import {
  collection,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  setDoc
} from "firebase/firestore";

import { db } from "../firebase";

const ONLINE_WINDOW_MS = 90 * 1000;
const HEARTBEAT_MS = 30 * 1000;

const timestampToDate = (value) => {
  if (!value) return null;
  if (typeof value.toDate === "function") return value.toDate();
  const parsedDate = new Date(value);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const isPresenceOnline = (presence) => {
  if (!presence?.isOnline) return false;

  const lastSignalDate =
    timestampToDate(presence.updatedAt) || timestampToDate(presence.lastSeen);

  if (!lastSignalDate) return false;

  return Date.now() - lastSignalDate.getTime() <= ONLINE_WINDOW_MS;
};

export const setUserOffline = async (uid) => {
  if (!uid) return;

  await setDoc(
    doc(db, "userPresence", uid),
    {
      isOnline: false,
      lastSeen: serverTimestamp(),
      updatedAt: serverTimestamp()
    },
    { merge: true }
  );
};

export const startUserPresence = ({ uid, email, name, role, photoURL }) => {
  if (!uid) return () => {};

  const presenceRef = doc(db, "userPresence", uid);

  const writeOnlineSignal = () => {
    setDoc(
      presenceRef,
      {
        uid,
        email: email || "",
        name: name || email || "Kullanıcı",
        role: role || "viewer",
        photoURL: photoURL || "",
        isOnline: true,
        lastSeen: serverTimestamp(),
        updatedAt: serverTimestamp()
      },
      { merge: true }
    ).catch((error) => {
      console.error("Çevrimiçi durum güncellenemedi:", error);
    });
  };

  const writeOfflineSignal = () => {
    setUserOffline(uid).catch(() => {});
  };

  const handleVisibilityChange = () => {
    if (document.visibilityState === "visible") {
      writeOnlineSignal();
    }
  };

  writeOnlineSignal();

  const heartbeatInterval = window.setInterval(
    writeOnlineSignal,
    HEARTBEAT_MS
  );

  window.addEventListener("beforeunload", writeOfflineSignal);
  document.addEventListener("visibilitychange", handleVisibilityChange);

  return () => {
    window.clearInterval(heartbeatInterval);
    window.removeEventListener("beforeunload", writeOfflineSignal);
    document.removeEventListener("visibilitychange", handleVisibilityChange);
    writeOfflineSignal();
  };
};

export const subscribePresenceUsers = (callback) => {
  const presenceQuery = query(
    collection(db, "userPresence"),
    orderBy("updatedAt", "desc")
  );

  return onSnapshot(presenceQuery, (snapshot) => {
    callback(
      snapshot.docs.map((presenceDoc) => ({
        id: presenceDoc.id,
        ...presenceDoc.data()
      }))
    );
  });
};
